import _ from 'underscore';
import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { getLocalStorage } from '@bingads-webui/storage';

/* global Map */
export function getToolbarConfig({
  onSelectCrossPage,
  scope,
  i18n,
  siteMap,
  permissions,
  serverContext,
}) {
  const isCurrentAccountInActive = serverContext.CurrentAccount.Status === 32; // 32 is InActive

  const toolbarSelectedConfig = _.reduce(
    [
      ['selection-widget', {
        type: 'selection-widget',
        onSelectCrossPage,
      }],
      ['divider', {
        type: 'divider',
      }],
      ['dropdown-edit', {
        id: 'dropdown-edit',
        type: 'dropdown',
        disabled: permissions.IsReadOnlyUser || isCurrentAccountInActive,
      }],
      ['expander', {
        type: 'expander',
      }],
      ['button-clear-selection', {
        type: 'button-clear-selection',
      }],
    ], (map, [key, value]) => {
      map.set(key, value);
      return map;
    },
    new Map()
  );

  const toolbarUnselectedConfig = _.reduce(
    _.compact([
      ['button-campaign-create', {
        id: 'button-campaign-create',
        type: 'button',
        text: i18n.getString(_TL_('Create campaign')),
        classes: ['btn-primary'],
        iconLeftGlyphName: 'ba-Add',
        noResponsive: true,
        onClick: () => {
          scope.save(getRoutePathById(siteMap, 'campaign-create-objective'));
          const localStorage = getLocalStorage();
          if (localStorage.supportsStorage()) {
            localStorage.set('fromPathId', 'settings');
          }
        },
        disabled: permissions.IsReadOnlyUser || isCurrentAccountInActive,
      }],
      ['expander', {
        type: 'expander',
      }],
      ['dropdown-column-chooser', {
        id: 'dropdown-column-chooser',
        type: 'dropdown',
        pullRight: true,
      }],
      ['Expand table', {
        type: 'expand-table',
      }],
    ]), (map, [key, value]) => {
      map.set(key, value);
      return map;
    },
    new Map()
  );
  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}
